// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__7Ybz-","searchInput":"SearchInput_searchInput__yBnu+"};